export const RoundedIcon = ({ content, className, children }) => {

  return (
    <div
      class={`flex items-center justify-center rounded-full border border-frame ${className != undefined ? className : ''}`}
    >
      {content || children}
    </div>
  )
}